// removed by extract-text-webpack-plugin
module.exports = {"comingSoonDisclaimerInfo":"src-components-ComingSoonOfferDisclaimer-___index__comingSoonDisclaimerInfo___3AiiH","comingSoonDisclaimerMessage":"src-components-ComingSoonOfferDisclaimer-___index__comingSoonDisclaimerMessage___3n1KL","disclaimerToggleIcon":"src-components-ComingSoonOfferDisclaimer-___index__disclaimerToggleIcon___1mdfB","comingSoonDisclaimerCentered":"src-components-ComingSoonOfferDisclaimer-___index__comingSoonDisclaimerCentered___13x3F","textContainer":"src-components-ComingSoonOfferDisclaimer-___index__textContainer___gAN9T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ComingSoonOfferDisclaimer/index.css
// module id = 452
// module chunks = 3